import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-decision-maker-accounts',
		path: '/decision-makers/:slug/admin_accounts',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_decisionMakerAccounts" */ './index'), {
			exportName: 'DecisionMakerAccounts',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff', 'support'],
		},
		frame: true,
	},
];
